import { Box, Button, FormControl, Stack, RadioGroup, Radio, FormErrorMessage, Spinner } from '@chakra-ui/react'
import { InsuranceParamsTravelDto, TravelDto } from 'BrokerTsLib/src/dtos'
import { Risk } from 'BrokerTsLib/src/enums'
import { Controller, FormProvider, useForm } from 'react-hook-form'
import * as global from 'brokertslib/src/helpers/global'
import _ from 'lodash'
import { FormLabel } from '../../components/FormLabel'
import { FormSpacer } from '../../components/FormSpacer'
import { InsuranceCompanies } from '../../components/InsuranceCompanies'

import { RadioStack } from '../../components/RadioStack'
import { useGetRiskVariants, useInsurers } from '../../hooks'
import { useNameof } from '../../hooks/useNameof'
import { useAddVariant } from '../../hooks/useWizardTravel'
import { Add } from '../../icons'
import { useInsuranceParamsContext } from '../../layouts/Wizard'
import { useState } from 'react'
import { useCestovkoOffersContext } from '../../context/CestovkoOffersProvider'
import { scrollToOfferWithOffset as scrollToElementId } from '../offers/OfferCar'

export const NewInsuranceSettings = ({ onSubmit }: { onSubmit?: Function }) => {
  const { insuranceParams, insuranceParamsId, refetchInsuranceParams } = useInsuranceParamsContext()
  const { refetchOffers } = useCestovkoOffersContext()
  const { mutateAsync: addVariant } = useAddVariant(insuranceParamsId!)
  const insuranceParamsTravel = insuranceParams as InsuranceParamsTravelDto
  const isContracted = !!insuranceParamsTravel.generalParams.contractNumber
  const [isSubmitting, setIsSubmitting] = useState(false)

  const methods = useForm<InsuranceParamsTravelDto>({
    defaultValues: insuranceParamsTravel
  })
  const {
    control,
    handleSubmit,
    formState: { errors },
    setError,
    watch
  } = methods

  const onSubmitForm = (data: InsuranceParamsTravelDto) => {
    setIsSubmitting(true)
    let values = _.cloneDeep(data)

    var promise = new Promise(function (resolve, reject) {
      addVariant(values)
        .then((response) => {
          refetchInsuranceParams()
          refetchOffers()
          scrollToElementId('steps')
          resolve(response)
          onSubmit && onSubmit(response)
        })
        .catch((err) => {
          if (!(err.response && err.response.status === 400 && err.response.data))
            return;

          let data = err.response.data

          // zobrazeni serverove validace
          Object.keys(data).forEach((x: any) => {
            setError(global.toCamelCase(x), { message: data[x].join(' ') })
          })

          reject(err)
        })
        .finally(() => {
          setIsSubmitting(false)
        })

    })

    return promise
  }

  const { data: dataRange, isLoading: isLoadingRange, isFetching: isFetchingRange } = useGetRiskVariants(Risk.TRAVEL_RANGE)
  const { data: allInsurers, isLoading: isLoadingInsurers, isFetching: isFetchingInsurers } = useInsurers(false, null)

  const nameof = useNameof<InsuranceParamsTravelDto>()
  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onSubmitForm)}>
        <Box sx={{ display: 'grid', gap: 4, placeItems: 'start' }}>

          <FormControl isRequired isInvalid={!!errors.travel?.range}>
            <Stack direction={'row'}>
              <FormLabel tooltip="Rozsah pojištění">Rozsah pojištění</FormLabel>
              {(isFetchingRange || isLoadingRange) && <Spinner />}
            </Stack>
            <Controller
              name="travel.range"
              control={control}
              render={({ field: { onChange, value } }) => {
                return (
                  <RadioGroup onChange={e => onChange(parseInt(e))} value={value?.toString() ?? ''} isDisabled={isContracted}>
                    <RadioStack variant="stackedTile">
                      {dataRange?.data?.filter(x => x.value != 'ALL').map((item) => (
                        <Radio value={item.id.toString()} key={item.id}>
                          {item.name}
                        </Radio>
                      ))}
                    </RadioStack>
                  </RadioGroup>
                )
              }}
            />

            {errors.travel?.range && <FormErrorMessage>{errors.travel.range.message}</FormErrorMessage>}
          </FormControl>
          <FormSpacer />

          <FormControl isInvalid={!!errors.baseParams?.insurers}>
            <InsuranceCompanies
              companies={(allInsurers?.data ?? [])}
              isLoadingCompanies={(isFetchingInsurers || isLoadingInsurers)}
              propPath={nameof(x => x.baseParams!.insurers)}
              isDisabled={isContracted}
            />
            {errors.baseParams?.insurers && <FormErrorMessage>{errors.baseParams.insurers.message}</FormErrorMessage>}
          </FormControl>

          <Button type="submit" variant="outline" isLoading={isSubmitting}>
            <Add color="secondary.500" />
            Přidat do kalkulace
          </Button>
        </Box>
      </form>
    </FormProvider>
  )
}
